import { transparentize } from "@chakra-ui/theme-tools";
import cssStyles from "./css-styles";
import { CustomStyleFunctionProps } from "./types";

export const reactApexChartStyles = ({ theme }: CustomStyleFunctionProps) => ({
  "&.apexcharts-canvas": {
    // Tooltip
    ".apexcharts-xaxistooltip": {
      ...cssStyles(theme).bgBlur(),
      border: 0,
      color: theme.colors.text,
      boxShadow: theme.shadows.sm,
      borderRadius: Number(theme.radii.sm) * 1.5,
      "&:before": { borderBottomColor: "transparent" },
      "&:after": {
        borderBottomColor: transparentize(
          theme.colors.white || theme.colors.black,
          0.8,
        ),
      },
    },
    ".apexcharts-tooltip.apexcharts-theme-light": {
      ...cssStyles(theme).bgBlur(),
      border: 0,
      boxShadow: theme.shadows.sm,
      borderRadius: Number(theme.radii.sm) * 1.5,
      "& .apexcharts-tooltip-title": {
        border: 0,
        textAlign: "center",
        fontWeight: theme.fontWeights["bold"],
        backgroundColor: transparentize(theme.colors.blueGray[500], 0.16),
        color: theme.colors.text,
      },
    },
    // Legend
    ".apexcharts-legend": {
      padding: 0,
    },
    ".apexcharts-legend-series": {
      display: "flex !important",
      alignItems: "center",
    },
    ".apexcharts-legend-marker": {
      marginRight: 8,
    },
    ".apexcharts-legend-text": {
      lineHeight: "18px",
      textTransform: "capitalize",
    },
  },
});
